import type { ReactNode } from 'react';

export const symbol_align_items_stretch: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-250q-12.75 0-21.37-8.63Q290-267.25 290-280v-400q0-12.75 8.63-21.38Q307.25-710 320-710h40q12.75 0 21.38 8.62Q390-692.75 390-680v400q0 12.75-8.62 21.37Q372.75-250 360-250h-40Zm280 0q-12.75 0-21.37-8.63Q570-267.25 570-280v-400q0-12.75 8.63-21.38Q587.25-710 600-710h40q12.75 0 21.38 8.62Q670-692.75 670-680v400q0 12.75-8.62 21.37Q652.75-250 640-250h-40ZM110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm0-740q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-880 110-880h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Z"
		/>
	</svg>
);
